/**
 * Labstep
 *
 * @module core/List/Collapsible
 * @desc List with collapsible sections
 */

import { Collapsible } from 'labstep-web/core/Collapsible';
import { List } from 'labstep-web/core/List';
import { TextWithCount } from 'labstep-web/core/Text/WithCount';
import type React from 'react';
import type {
  IListCollapsibleProps,
  IListCollapsibleSectionProps,
} from './types';

export const ListCollapsibleSection: React.FC<
  IListCollapsibleSectionProps
> = ({
  icon,
  text,
  count,
  component,
  initialExpandedState = true,
}) =>
  count ? (
    <Collapsible
      label={<TextWithCount icon={icon} text={text} count={count} />}
      component={component}
      initialExpandedState={initialExpandedState}
    />
  ) : null;

export const ListCollapsible: React.FC<IListCollapsibleProps> = ({
  sections,
}) => (
  <List>
    {sections.map(
      ({ icon, text, count, component, initialExpandedState }, i) => (
        <ListCollapsibleSection
          // FIXME react/no-array-index-key
          key={i}
          icon={icon}
          text={text}
          count={count}
          component={component}
          initialExpandedState={initialExpandedState}
        />
      ),
    )}
  </List>
);
